import { useEffect } from 'react';
import { useRouter } from 'next/router';
import { useSession } from './SessionContext';

type Props = {
  children: React.ReactNode;
};

const LogoutRequired = ({ children }: Props) => {
  const { user, loadingUser } = useSession();
  const router = useRouter();

  useEffect(() => {
    if (!loadingUser && user) {
      void router.push('/');
    }
  }, [user, router, loadingUser]);

  return <>{children}</>;
};

export default LogoutRequired;
